import { Component, Input, OnInit } from '@angular/core';
import { ProfileService } from 'app/core/services/profile.service';
import { CompareType } from 'app/shared/components/ag-grid-dynamic/grid-types';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { FieldTypes, statusPayment } from 'app/shared/model/enums';
import { CommonService } from 'app/shared/services/common.service';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { PaymentsBase } from '../payments-base';

@Component({
  selector: 'app-profile-payments',
  templateUrl: './profile-payments.component.html',
  styleUrls: ['./profile-payments.component.scss']
})
export class ProfilePaymentsComponent  extends PaymentsBase  implements  OnInit{
  constructor(profileService: ProfileService,messageService: MessageService,localizationService: LocalizationService) { 
    super(profileService, messageService, localizationService)
  }
  ngOnInit(): void {
    this.initTable()
    this.fillData();
  }
}
